<template lang="pug">
FormSignup(key='signup', :validateBeforeSubmit='true', @submit='signUp').form__sign_up
</template>

<script>
import FormSignup from '../default/popup/forms/signup';
export default {
  name: 'Register',
  components: { FormSignup },
  props: {
    redirect: {
      type: String,
      default: '',
    },
  },
  methods: {
    signUp() {
      let _redirect = this.redirect;
      this.$nextTick(() => {
        this.$router.push({ name: _redirect ? _redirect : 'home' });
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.form__sign_up
  max-width: 1050px;
  align-self: center;
</style>



// WEBPACK FOOTER //
// Register.vue?78241c8b